// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__DoLNb{
    width:100%;
    height:100%;
    min-height: unset !important;
    margin-bottom:0px;
}
.styles_container__DoLNb *{
    cursor:default !important;
}
.styles_container__DoLNb>div>div>div{
    max-width:250px !important;
}
.styles_content__6kJFc{
    width:100%;
    height:100%;
    margin-bottom: unset !important;
    border-radius: 10px;
    border: 0.5px solid rgba(0, 0, 0, 0.50);
    padding: 5px 28px;

}
.styles_text__H496N{
    color: #000;
    text-align: right;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    word-break: normal;
}
.styles_absoluteBg__KkivM{
    width:100%;
    height:100%;
    position:absolute;
    top:0;
    left:0;
    opacity:0.5;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ChatDemo/styles.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,mBAAmB;IACnB,uCAAuC;IACvC,iBAAiB;;AAErB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,WAAW;AACf","sourcesContent":[".container{\n    width:100%;\n    height:100%;\n    min-height: unset !important;\n    margin-bottom:0px;\n}\n.container *{\n    cursor:default !important;\n}\n.container>div>div>div{\n    max-width:250px !important;\n}\n.content{\n    width:100%;\n    height:100%;\n    margin-bottom: unset !important;\n    border-radius: 10px;\n    border: 0.5px solid rgba(0, 0, 0, 0.50);\n    padding: 5px 28px;\n\n}\n.text{\n    color: #000;\n    text-align: right;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    word-break: normal;\n}\n.absoluteBg{\n    width:100%;\n    height:100%;\n    position:absolute;\n    top:0;\n    left:0;\n    opacity:0.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__DoLNb`,
	"content": `styles_content__6kJFc`,
	"text": `styles_text__H496N`,
	"absoluteBg": `styles_absoluteBg__KkivM`
};
export default ___CSS_LOADER_EXPORT___;
